export function timelineItemAdded() {
    const event = new CustomEvent("pos/timeline_item_added");
    document.dispatchEvent(event);
}